import { ExportColumn } from '../../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: 'Facility/Utility',
    type: 'text',
    width: 35,
  },
  {
    key: 'available',
    header: 'Available',
    type: 'boolean',
    placeholder: 'Not Provided',
  },
  {
    key: 'adequate',
    header: 'Adequate',
    type: 'boolean',
    placeholder: 'Not Provided',
  },
  {
    key: 'rampUpTime',
    header: 'Ramp-Up Time (months)',
    type: 'number',
  },
  {
    key: 'contactFirstName',
    header: 'Internal Contact First Name',
    placeholder: 'Not Provided',
    type: 'text',
    width: 35,
  },
  {
    key: 'contactLastName',
    header: 'Internal Contact Last Name',
    placeholder: 'Not Provided',
    type: 'text',
    width: 35,
  },
  {
    key: 'email',
    header: 'Internal Contact Email',
    placeholder: 'Not Provided',
    type: 'email',
    width: 35,
  },
];
